module.exports = __webpack_public_path__ + "img/a3.50e7d12e.png";